module.exports = __webpack_public_path__ + "static/media/2.01eadc43.png";